import { useState } from "react";
import SettingsPane from "./SettingsPane";

const Navbar = () => {
    const [settingsPaneVisible, setSettingsPaneVisible] = useState(false);

    const handleOpenSettingsPane = () => {
        setSettingsPaneVisible(true);
        document.body.style.overflow = 'hidden';
    }
    const handleCloseSettingsPane = () => {
        setSettingsPaneVisible(false);
        document.body.style.overflow = 'auto';
    }

    return ( 
        <div>
        <nav id = 'navbar' className="navbar">
            <img className="logo" src="logo.png"/>

            <div className="info-options" onClick={handleOpenSettingsPane}>
                <img className="help-img" src="help.png" alt="Option"/>
            </div>

        </nav>
        {settingsPaneVisible && <div className="help">
                <SettingsPane onClose={handleCloseSettingsPane}/>
                <div className="overlay" onClick={handleCloseSettingsPane}/>
            </div>}
        </div>
    );
}
 
export default Navbar;